import { has } from 'lodash'
import { BaseOutput, isBaseOutput } from './base-output.model'
import { isThinRegistrationBaseOutput, ThinRegistrationBaseOutput } from './thin-registration-base-output.model'

export interface ConfirmPhoneOTPOutput extends ThinRegistrationBaseOutput, BaseOutput {
  /* eslint-disable @typescript-eslint/naming-convention */
  AttemptBlockedUntil: string
  AvailableAttempts: null
  IsOTPVerified: boolean
  /* eslint-enable @typescript-eslint/naming-convention */
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isConfirmPhoneOTPOutput = (obj: any): obj is ConfirmPhoneOTPOutput => {
  const attemptBlockedUntil = 'AttemptBlockedUntil'
  const availableAttempts = 'AvailableAttempts'
  const isOTPVerified = 'IsOTPVerified'

  return (
    isThinRegistrationBaseOutput &&
    isBaseOutput(obj) &&
    has(obj, attemptBlockedUntil) &&
    has(obj, availableAttempts) &&
    has(obj, isOTPVerified)
  )
}
